import { EXCLUDED_COUNTRIES } from "@config/consts";

import { AVAILABLE_COUNTRIES, AVAILABLE_LANGS } from "@typings/globals";

export const getCountriesList = (
  translate: (k: string) => string,
): { value: AVAILABLE_COUNTRIES; label: string }[] =>
  Object.values(AVAILABLE_COUNTRIES)
    .filter(country => !EXCLUDED_COUNTRIES.includes(country))
    .map(country => ({
      value: country,
      label: translate(`batmaid_pwa_generic.country_${country}`),
    }));

export const getLanguagesList = (): AVAILABLE_LANGS[] =>
  Object.values(AVAILABLE_LANGS) as AVAILABLE_LANGS[];
